import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Project } from 'src/app/core/interfaces/production/project';
import { ApiService } from 'src/app/core/services/api/api.service';

@Component({
  selector: 'app-accounting-counts-list',
  templateUrl: './accounting-counts-list.component.html',
  styleUrls: ['./accounting-counts-list.component.scss'],
})
export class AccountingCountsListComponent implements OnInit {
  @Input() status: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [
    'customerName',
    'jobaddress',
    'estimatorName',
    'soldByName',
    'contractDate',
    'approvalDate',
    'projectShortName',
  ];

  dataSource: MatTableDataSource<Project>;
  dataSourceArray: Project[] = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();
    // this.getDataSource(this.status);
    this.route.paramMap.subscribe((params) => {
      this.status = params.get('status') as string;
      this.getDataSource(this.status);
    });
  }

  getDataSource(status: string) {
    this.dataSource = new MatTableDataSource();
    this.isLoading = true;

    if (status) {
      switch (status) {
        case 'projectsNeedingPayment':
          this.statusNumber = 0;
          this.statusMessage = 'Projects Needing Payment Collected';
          break;
      }
    }

    if (this.statusNumber != undefined) {
      // this.apiService.getAccountingCountsByStatus(this.statusNumber).subscribe({
      //   next: (projectArray) => {
      //     this.dataSourceArray = projectArray;
      //     this.dataSource = new MatTableDataSource(projectArray);
      //     this.dataSource.paginator = this.paginator;
      //     this.dataSource.sort = this.sort;
      //     this.isLoading = false;
      //   },
      // });
    }
  }

  // Figure out what to call this and the route etc
  goToAccountingInfo(row: Project) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        projectId: row.projectId,
        status: row.status,
        cclContact: true,
      },
    });
  }

  filterProjects(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterString.trim().toLowerCase();
  }
}
